import { PortalProductConfig, getProductWithVariants, ProductWithVariants } from '../../models/product';
import { SingleInsurantWidgetComponent } from '../../customer-portal/widgets/single-insurant-widget/single-insurant-widget.component';
import { defaultContractWidgets } from '../../config/default-contract-widgets';

const portalConfig: PortalProductConfig = {
    icon: 'tuition',
    widgets: [...defaultContractWidgets, { component: SingleInsurantWidgetComponent }],
};

export const tutoringInsurance: ProductWithVariants = getProductWithVariants({
    slug: 'nachhilfe-plus',
    title: 'Nachhilfe-Versicherung "Plus"',
    fullTitle: 'Nachhilfe-Versicherung "Plus"',
    insuranceTypeName: 'Nachhilfe Plus',
    insuranceTypeId: 14,
    legacy: true,
    portalConfig,
});
